import { memo } from 'react';
import { CopyToClipboardBase } from 'root/src/client/web/base/CopyToClipboardBase';
import toast from 'react-hot-toast';
export const ShareLinkDisplay = memo(({ url }) => {
    return (<CopyToClipboardBase onCopied={() => {
            toast.success('Link copied to clipboard');
        }} text={url}>
			<div className="flex flex-col gap-1 justify-center items-center">
				<p className="text-light-5 uppercase text-2xs text-center">
					Share link to help the developers:
				</p>
				<p className="text-teal font-mono text-sm text-center break-all">
					{url}
				</p>
				<p className="text-light-4 text-2xs text-center">
					Click to copy
				</p>
			</div>
		</CopyToClipboardBase>);
});
